<template>
  <img src="@/assets/img/logo.png">
</template>

<script>
export default {
  name: 'AtomLogoPrimary'
}
</script>
